import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const FilterButtonStyled = styled(Button)(() => ({
  position: 'relative',
  justifyContent: 'flex-start',
  width: '100%',
  '& .MuiButton-endIcon': {
    position: 'absolute',
    right: '8px'
  }
}));

export const OptionButtonStyle = {
  borderRadius: 3,
  '&.MuiButton-sizeSmall': {
    padding: '10px'
  }
};
